<template>
  <div class="index">
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="btns" style="display:none">
          <span class="cancel">取消</span>
          <span class="confirm">确定</span>
        </p>
        <p class="foot"></p>
      </div>
    </div>
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="main" id="indexPage">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <img src="../images/index_top.png" alt width="100%" />
        </van-swipe-item>
        <van-swipe-item>
          <img src="../images/shop_top.jpeg" alt width="100%" />
        </van-swipe-item>
      </van-swipe>

      <div class="banner">
        <img src="../images/index_wifilogo.png" width="31.733%" />
        <p>一键连WiFi，一直有保障</p>
      </div>
      <div class="detail clearfix">
        <div class="protect">
          <p>保障清单</p>
          <div class="line left"></div>
          <div class="line right"></div>
        </div>
        <div class="detail-item">
          <div class="left">连WiFi意外损失累计最高赔付</div>
          <div class="right">
            ￥
            <span class="big">100,000</span>元
          </div>
        </div>
        <div class="detail-item">
          <div class="left">连WiFi意外损失单次最高赔付</div>
          <div class="right">
            ￥
            <span class="big">20,000</span>元
          </div>
        </div>
        <div class="detail-item">
          <div class="left">保障期限</div>
          <div class="right">一年</div>
        </div>
        <div class="detail-item">
          <div class="left">参保费用</div>
          <div class="right">
            ￥
            <span class="big">0.00</span>元
          </div>
        </div>
        <div class="btn" @click="toRange()">查看保险详情</div>
      </div>
      <div class="detail clearfix">
        <div class="protect">
          <p>专属特色</p>
          <div class="line left"></div>
          <div class="line right"></div>
        </div>
        <div class="left-panel">
          <div class="icon icon1"></div>
          <p style="color:#333333">全方位保障</p>
          <p>所有通过WiFi万能钥匙</p>
          <p>连WiFi的上网行为</p>
        </div>
        <div class="right-panel">
          <div class="icon icon2"></div>
          <p style="color:#333333">官方VIP通道</p>
          <p>极速处理您的WiFi安全</p>
          <p>险理赔需求</p>
        </div>
      </div>
      <qa :type="1"></qa>
      <div class="logo-image"></div>
      <div class="copyright">南京尚网网络科技有限公司对以上信息保留最终解释权</div>
      <div class="button-fixed">
        <!-- 个人参保 -->
        <p class="button-item" id="createBtn" @click="goCreate('personal')">个人参保</p>
        <p class="button-item" @click="goCreate('store')">商户参保</p>
      </div>
    </div>
  </div>
</template>

<script>
import qa from "@/components/qa";
import { getInsuranceInfo } from "../services/common/index";
import { Swipe, SwipeItem } from "vant";

const AES = require("@/lib/Utils/AES").default;
export default {
  name: "newHome",
  components: {
    qa,
  },

  data() {
    return {
      msg: "tests",
      obj: "",
      shopObj: null,
      isFirst: true,
      appinfo: "",
      clickBtnName: "",
      isLogin: false, // 是否登录
      isDatail: false, // 个人详情？
      isShopDatail: false, // 商家详情？
      loading: false,
      appid: this.$route.query.appid,
    };
  },
  created() {
    this.$trace.trace('ins_join_show');
  },
  mounted() {
    this.$trace.trace('ins_join_load');
    // 检查登录状态
    Utils.Bridge.call("getAppInfo", {
      success: (o) => {
        this.appinfo = o;
        Utils.Bridge.call("checkLogin", {
          success: (bool) => {
            if (bool) {
              this.isLogin = true;
              this.isFirst = true;
              this.checkShopStatus();
              this.checkPersonalStatus();
              this.$trace.enterTraceDone({ page: 1, login: "have_login" });
            } else {
              this.isLogin = false;
              this.$trace.enterTraceDone({ page: 1, login: "no_login" });
            }
          },
        });
      },
    });

    Utils.Bridge.call("hideOptionMenu");
    setTimeout((_) => {
      Utils.Bridge.call("hideOptionMenu");
    }, 2000);
  },
  methods: {
    toRange: function () {
      this.$router.push("/new/rangePersonal");
      console.log(`查看保险详情`);
    },
    // 创建保单
    goCreate(val) {
      this.clickBtnName = val;
      console.log(`====`, this.isLogin, this.isDatail, this.isShopDatail);
      // 未登录
      if (!this.isLogin) {
        Utils.Bridge.call("login", {
          fromSource: "app_insurance",
          loginMode: 0,
          success: (ok) => {
            if (ok || this.$wkb.isWKBrowser === "ios") {
              this.isLogin = true;
              this.login();
              this.loginShop();
            }
          },
        });
      } else {
        // 已经登录
        this.$trace.trace("ins_join", "have_login");
        console.log(`参保：已登录`);
        if (val === "personal") {
          this.$trace.trace('ins_join_ind');
          if (this.isDatail) {
            this.goDetail(val);
            return;
          }
          sessionStorage.removeItem('PERSONAL_INFO')
          this.$router.push("/create");
        } else if (val === "store") {
          this.$trace.trace('ins_join_sup');
          let shopObj = this.shopObj;
          if (!shopObj) {
            this.$router.push("/new/createStore?clear=true&from=home");
          } else {
            this.handleStatePage();
          }
        }
      }
    },
    // 进入保单详情
    goDetail: function (val) {
      this.$router.push("/new/detail");
    },

    handleStatePage() {
      let state = this.shopObj.state;
      if (state == 0 || state == 1) {
        this.$router.push("/new/insureDetail");
      } else if (state == 2) {
        this.$router.push("/new/createSuccess?state=0");
      } else if (state == 3) {
        this.$router.push("/new/createSuccess?state=1");
      }
    },

    //  检查商户是否参保
    checkShopStatus(val) {
      getInsuranceInfo({})
        .then((res) => {
          const { data } = res;
          this.shopObj = data;
            this.isShopDatail = true;
          if (this.isFirst === "first") {
          } else {
            if (this.clickBtnName === "store") {
              this.handleStatePage();
            }
          }
        })
        .catch((err) => {
          const { retCd, msg } = err;
          if (retCd === "T.XQA.2005") {
            if (this.clickBtnName === "store") {
              this.$router.push("/new/createStore");
            }
          }
        });
    },

    // 检查个人参保状态
    checkPersonalStatus(type) {
      var _self = this;
      _self.loading = true;

      let data = {
        dhid: _self.appinfo.dhid,
        uhid: _self.appinfo.uhid,
        vcode: _self.appinfo.vcode,
      };
      let ed = AES.Encrypt(JSON.stringify(data), AES.obj());

      this.$http
        .post(
          _host + "/user/get",
          {
            ed: ed,
          },
          {
            emulateJSON: true,
          }
        )
        .then(function (response) {
          _self.loading = false;
          var json = response.body;
          if (json.c == "0000") {
            document.title = "WiFi安全险";
            this.isDatail = true;
            if (this.isFirst === "first") {
            } else {
              if (this.clickBtnName === "personal") {
                this.$router.push("/new/detail");
              }
            }

            if (!type) {
              // 非登录状态
              _self.$trace.enterTraceDone({ page: 2 });
            }
            _self.$trace.enterTraceDone({ page: 2 });
            _self.obj = json.m;
            _self.obj.end_time = _self.obj.end_time || "2023年9月15日24时";
            var status = json.m.status,
              hasList = json.m.has_list;
            if (status == "2") {
              $("body").addClass("claim");
            }
          } else {
            if (this.isFirst === "first") {
            } else {
              // 登录状态直接创建
              if (this.clickBtnName === "personal") {
                sessionStorage.removeItem('PERSONAL_INFO')
                _self.$router.push("/create");
              }
            }
          }
        });
    },
    loginShop() {
      console.log(`商家参保：未登录`);
      this.checkShopStatus("login");
    },
    login() {
      var trackerB = "";
      if ($(this).attr("id") == "createBtn") {
        trackerB = "ins_freepro_login";
      } else {
        trackerB = "ins_mypro";
      }
      this.$trace.trace("ins_join", "no_login");
      console.log(`参保：未登录`);

      Utils.Bridge.call("getAppInfo", {
        success: (o) => {
          this.appinfo = o;
          this.checkPersonalStatus("login");
        },
      });
    },
  },
};
</script>

<style scoped>
.halfwidth {
  width: 50% !important;
}
.main {
  width: 100%;
  overflow-x: hidden;
  margin: 0 auto;
}
.banner {
  padding: 4% 4.8%;
  margin-bottom: 11px;
  background: #fff;
}

.button-fixed {
  width: 100%;
  line-height: 50px;
  font-size: 18px;
  text-align: center;
  position: fixed;
  bottom: 0px;
  display: flex;
}
.button-item {
  width: 100%;
  line-height: inherit;
  text-align: center;
  background-image: linear-gradient(-90deg, #42a9fd 0%, #0285f0 99%);
  color: #ffffff;
}

.banner p {
  padding: 0;
  color: #787878;
  font-size: 13px;
  line-height: 21px;
}
.protect {
  position: relative;
  text-align: center;
}
.protect p {
  font-size: 16px;
  line-height: 60px;
  color: #000;
  font-weight: 600;
}
.protect .line {
  position: absolute;
  top: 29px;
  width: 34.66%;
  height: 1px;
  background: #e8e8e8;
}
.protect .left {
  left: -1%;
}
.protect .right {
  right: -1%;
}
.detail-item {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
}
.detail-item .left {
  float: left;
  color: #626262;
  vertical-align: middle;
  height: 32px;
  font-weight: 300;
}
.detail-item .right {
  float: right;
  color: #151515;
  vertical-align: middle;
  height: 32px;
}
.detail-item .big {
  float: none;
  font-size: 22px;
  color: #3474b8;
  margin: 0 3px;
}
.detail .btn {
  color: #0285f0;
  font-size: 14px;
  line-height: 60px;
}
.detail .left-panel,
.detail .right-panel {
  position: relative;
  display: inline-block;
  width: 49%;
  padding: 0;
  margin: 0;
  padding-bottom: 43px;
}
.detail .right-panel {
}
.detail .icon {
  width: 100%;
  padding-top: 28%;
  margin-top: 26px;
  margin-bottom: 17px;
}
.icon1 {
  background: url(../images/index/icon1.png) no-repeat center;
  background-size: contain;
}
.icon2 {
  background: url(../images/index/icon2.png) no-repeat center;
  background-size: contain;
}
.detail .left-panel p,
.detail .right-panel p {
  padding: 0;
  margin: 0;
  color: #3f3f3f;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
}
.logo-image {
  margin-top: 30px;
  width: 100%;
  padding-top: 2.9%;
  background: url(../images/index/logo-image.png) no-repeat center;
  background-size: contain;
}
.copyright {
  font-size: 12px;
  line-height: 26px;
  color: #e0e0e0;
  text-align: center;
  font-weight: 300;
  padding-bottom: 60px;
}
.title .already {
  font-size: 14px;
  line-height: 26px;
  color: #666666;
  font-weight: 400;
  padding-bottom: 14px;
  border-bottom: 1px solid #e8e8e8;
}
.al-item {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
}
.al-item .left {
  float: left;
}
.al-item .right {
  float: right;
}
.al-item .a {
  display: block;
  text-decoration: underline;
  color: #0285f0;
}
</style>



// WEBPACK FOOTER //
// home.vue?3f6f1f6e